import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { useNavigateToPost } from "../../hooks/useNavigateToPost"
import { SmartDateFormat } from "../../util/dates"
import CommentSectionPreview from "../comments/CommentSectionPreview"
import { TextAsImage } from "./TextAsImage"
import { PostListItemStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import { UserContext } from "../HomeApp"
import clsx from "clsx"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"
import { PostListItemParams } from "../../types/posts"

export const EditorialListItem: React.FC<PostListItemParams> = ({
  post,
}) => {
  const { user } = useContext(UserContext)
  const navigateToPostScreen = useNavigateToPost(post.nada_path)

  return (
    <div className="grid grid-cols-12">
      <div className={PostListItemStyles.contentDiv}>
        {post.cover_image_url_large ? (
          <img
            src={post.cover_image_url_large}
            alt={post.title}
            onClick={navigateToPostScreen}
            className={clsx(
              styles.editorialHeaderImage,
              "cursor-pointer",
              "w-full",
            )}
          />
        ) : (
          <TextAsImage text={post.title} />
        )}
      </div>

      <div className={PostListItemStyles.metaDiv}>
        <PremiereHeader post={post} size="small" />
        <div className="flex items-start justify-between">
          <div>
            <h2
              className={clsx(
                PostListItemStyles.header,
                post.title.length > 100
                  ? PostListItemStyles.headerLong
                  : PostListItemStyles.headerShort,
                "cursor-pointer",
                post.is_bn_premiere && styles.premiereTitle,
              )}
              onClick={navigateToPostScreen}
            >
              {post.title}
            </h2>
          </div>
          <ShareUrlButton nadaUrl={post.nada_url} renderMode="icon" />
        </div>
        <div className={styles.subtitle}>{post.subtitle}</div>

        <Link className={PostListItemStyles.bandName} to={post.local_path}>
          {post.band_name}
        </Link>
        <h3 className={PostListItemStyles.postDate}>
          {SmartDateFormat({
            dateStr: post.published_at,
            includeTime: false,
          })}
        </h3>
        <div className={styles.editorialBlurb}>
          {post.editorial_blurb}...
          <div className="mt-2">
            <button
              className="text-blue-500 text-sm focus:outline-none"
              onClick={navigateToPostScreen}
            >
              Read Full Post
            </button>
          </div>
        </div>
        <div className="mt-4">
          <RelatedPosts postId={post.id} />
        </div>
        <div className="mt-6">
          <ReactionBlock
            contentType="Post"
            contentId={post.id}
            postId={post.id}
          />
        </div>
        <CommentSectionPreview
          postId={post.id}
          postPath={post.nada_url}
        />
      </div>
    </div>
  )
}
